<template>
  <div>
    <el-checkbox v-show="checkAllShow" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
    <div v-show="checkAllShow" style="margin: 5px 0;"></div>
    <el-checkbox-group
      v-model="selectValues"
      @change="toParent">
      <el-checkbox v-for="item in options"
                   :key="item.keyValue"
                   :label="item.keyValue"
                   :value="item.keyValue">
        <span :style="style">{{item.keyName}}</span>
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
import { querySysMediaParam } from '@/api/common'
// import {getTenantSystemModule} from '@/api/operation'
import { queryCommonConfParam } from '@/api/oms'
import {getAllRole, getAllPosition} from '@/api/roleManage'
export default {
  props: {
    checkData: {
      required: false,
      type: Array
    },
    tenantId: {
      required: false,
      type: Number,
      default: -1
    },
    orgId: {
      type: String,
      required: false,
      default: ''
    },
    tenantTypeId: {
      type: Number,
      required: false
    },
    orgKey: {
      type: String,
      required: false,
      default: ''
    },
    checkedValues: {
      type: Array,
      required: false
    },
    propertyType: {
      type: String,
      required: true,
      default: 'PROJECT_LEVEL'
    },
    selectType: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    checkAllShow: {
      type: Boolean,
      required: false,
      default: false
    },
    width: {
      type: String,
      required: false,
      default: ''
    },
    customizeStyle: {
      type: Boolean,
      required: false,
      default: false
    },
    indexKey: {
      type: Number,
      required: false,
      default: 0
    },
    value: null
  },
  data () {
    return {
      checkAll: false,
      isIndeterminate: false,
      selectValues: this.value === undefined ? [] : this.value,
      options: [],
      style: {}
    }
  },
  watch: {
    value (val) {
      this.selectValues = val
    },
    checkData (val) {
      this.options = []
      if (val) {
        val.forEach(m => {
          this.options.push({
            keyValue: m.moduleId,
            keyName: m.moduleName
          })
        })
      }
    }
    // tenantTypeId (val) {
    //   this.options = []
    //   if (val && val !== -1) {
    //     this.getTenantSystemModule(this.orgKey, val)
    //   }
    // }
  },
  created () {
    this.searchData()
    if (this.customizeStyle) {
      this.style = {
        width: '120px',
        display: 'inline-block'
      }
    } else {
      this.style = {}
    }
  },
  methods: {
    async toParent () {
      let checkedCount = this.selectValues.length
      this.checkAll = checkedCount === this.options.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length
      this.$forceUpdate()
      this.$emit('data', this.selectValues, this.propertyType, this.indexKey, this.orgId)
    },
    handleCheckAllChange (val) {
      if (val) {
        let items = []
        this.options.forEach(function (item, index) {
          items.push(item.keyValue)
        })
        this.selectValues = items
      }
      if (!val) {
        this.selectValues = []
      }
      this.isIndeterminate = false
      this.$emit('data', this.selectValues, this.propertyType)
    },
    async searchData () {
      let commonModel = {
        filter: ''
      }
      this.options = []
      if (this.propertyType === null || this.propertyType === undefined) {
        return
      }
      commonModel.filter = 'type=' + this.propertyType + ';' + 'tenantId=' + this.tenantId
      if (this.propertyType === 'PROJECT_STATE') {
        this.options = [
          {keyValue: 1, keyName: '可售'},
          {keyValue: 2, keyName: '维护'},
          {keyValue: 3, keyName: '预拆除'},
          {keyValue: 4, keyName: '拆除'},
          {keyValue: 5, keyName: '已到期'}]
      } else if (this.propertyType === 'PROJECT_MEDIA') {
        this.options = [
          {keyValue: 1, keyName: '可售'},
          {keyValue: 2, keyName: '维护'},
          {keyValue: 3, keyName: '预拆除'},
          {keyValue: 4, keyName: '拆除'},
          {keyValue: 5, keyName: '已到期'}]
      } else if (this.propertyType === 'ELEVATOR_POSITION') {
        this.options = [
          {keyValue: 1, keyName: '梯内'},
          {keyValue: 2, keyName: '大堂'},
          {keyValue: 3, keyName: '独立大堂'},
          {keyValue: 4, keyName: 'B1大堂'},
          {keyValue: 5, keyName: 'B2大堂'},
          {keyValue: 6, keyName: 'B3大堂'},
          {keyValue: 7, keyName: 'B4大堂'}]
      } else if (this.propertyType === 'FLOOR_POSITION') {
        this.options = [
          {keyValue: 1, keyName: '梯内'},
          {keyValue: 2, keyName: '一层梯外'},
          {keyValue: 3, keyName: '负一层梯外'},
          {keyValue: 4, keyName: '负二层梯外'},
          {keyValue: 5, keyName: '负三层梯外'},
          {keyValue: 6, keyName: '其他楼层'}]
      } else if (this.propertyType === 'USER_ROLE') {
        let res = await getAllRole()
        let result = res.data.data
        if (result.length > 0) {
          result.forEach(m => {
            this.options.push({
              keyValue: m.roleId,
              keyName: m.roleName
            })
          })
        }
      } else if (this.propertyType === 'USER_POSITION') {
        let res = await getAllPosition()
        let result = res.data.data
        if (result.length > 0) {
          result.forEach(m => {
            this.options.push({
              keyValue: m.positionId,
              keyName: m.positionName
            })
          })
        }
      } else if (this.propertyType === 'SYSTEM_MODULE') {
        // await this.getTenantSystemModule(this.orgKey, this.tenantTypeId)
        this.options = []
        if (this.checkData) {
          this.checkData.forEach(m => {
            this.options.push({
              keyValue: m.moduleId,
              keyName: m.moduleName
            })
          })
        }
      } else if (this.propertyType === 'PROJECT_TYPE' || this.propertyType === 'PROJECT_LEVEL' || this.propertyType === 'MEDIA_TYPE' || this.propertyType === 'MEDIA_SIZE') {
        let res = await queryCommonConfParam(this.propertyType)
        let datas = res.data.data
        datas.forEach(m => {
          this.options.push({keyValue: parseInt(m.optionValue), keyName: m.optionName})
        })
      } else {
        let res = await querySysMediaParam(commonModel)
        this.options = res.data.data.aaData
      }
      await this.toParent()
    },
    // getTenantSystemModule (orgKey, tenantTypeId) {
    //   getTenantSystemModule(orgKey, tenantTypeId).then(res => {
    //     let result = res.data.data
    //     if (result.length > 0) {
    //       let temp = []
    //       result.forEach(m => {
    //         temp.push({
    //           keyValue: m.moduleId,
    //           keyName: m.moduleName
    //         })
    //       })
    //       this.options = temp
    //     }
    //   })
    // },
    clearValue () {
      this.selectValues = []
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/checkbox/index.vue